import { useNavigate } from 'react-router-dom';
import PageRoute from 'core/page-route';

const useGotoRecurringPayment = () => {
  const navigate = useNavigate();
  return () => navigate(PageRoute.account.payment.recurringPayment);
}

export default useGotoRecurringPayment;